import { render, staticRenderFns } from "./FichaDigital.vue?vue&type=template&id=367c067f&scoped=true&"
import script from "./FichaDigital.vue?vue&type=script&lang=js&"
export * from "./FichaDigital.vue?vue&type=script&lang=js&"
import style0 from "./FichaDigital.vue?vue&type=style&index=0&id=367c067f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367c067f",
  null
  
)

export default component.exports